import React from 'react';
import { withRouter } from 'react-router-dom';

import { connect } from '../StateProvider';
import NavRoute from '../common/router/Route';
import NavRedirect from '../common/router/Redirect';
import routes from '../../routes';
import { VIEW_MODES, SETTINGS_KEYS } from '../../configs/viewSettings';

import DataProvider from './DataProvider';
import { SCALES } from './helpers/scales';

const Gantt = (props) => {
  const { savedScale } = props;

  return (
    <NavRoute
      route={routes.ganttSettings}
      children={({ match }) => {
        const scale = match && match.params.scale;

        if (!SCALES[scale]) {
          return <NavRedirect route={routes.ganttSettings} params={{ scale: savedScale }} />;
        }

        return <DataProvider {...props} scale={scale} />;
      }}
    />
  );
};

export default connect(
  withRouter(Gantt),
  {
    viewSettings: ['viewSettings', 'catalogs'],
  },
  (props, { viewSettings }) => {
    const { catalogId, viewId } = props;
    const savedScale =
      viewSettings.getIn([catalogId, 'views', viewId, VIEW_MODES.GANTT, SETTINGS_KEYS.GANTT_SCALE]) || 'day';

    return { ...props, savedScale };
  },
);
